export default [
  {
    path: "/qe",
    children: [
        //students
      {
        path: "students",
        name: "qe-students",
        component: () =>
          import("@/views/qe/students/index.vue"),
        meta: {
          title: "QE STUDENTS",
          authRequired: true,
          acc: 'y13985'
        },
      },
        //students
      {
        path: "qe-studentslsi",
        name: "qeStudentsList",
        component: () => import("@/views/qe/students/list.vue"),
        meta: {
          title: "QE Students list",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "view-student/:id?",
        name: "qeStudent",
        component: () =>
          import("@/views/qe/students/view.vue"),
        meta: {
          title: "QE VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student",
        name: "qe-edit-student",
        component: () =>
          import(
            "@/views/qe/students/components/edit.vue"
          ),
        meta: {
          title: "EDIT STUDENT",
          authRequired: true,
        },
      },
      //register
      {
        path: "register",
        name: "qe-register",
        component: () =>
          import("@/views/qe/register.vue"),
        meta: {
          title: "REGISTER",
          authRequired: true,
        },
      },
      //Cas
      {
        path: "cas",
        name: "qe-cas",
        component: () =>
          import("@/views/qe/cas/index.vue"),
        meta: {
          title: "CAS",
          authRequired: true,
          acc: 'y13529'
        },
      },
      {
        path: "withca/:id?",
        name: "qeWithCas",
        component: () =>
          import("@/views/qe/cas/withca.vue"),
        meta: {
          title: "QE With C.A",
          authRequired: true,
          acc: 'y15756'
        },
      },
      {
        path: "nonreg/:id?",
        name: "qeWithoutCas",
        component: () =>
          import("@/views/qe/cas/withoutca.vue"),
        meta: {
          title: "QE NON REG CAS",
          authRequired: true,
          acc: 'y15756'
        },
      },
      {
        path: "editca/:id?",
        name: "qe-editca",
        component: () =>
          import("@/views/qe/cas/edit.vue"),
        meta: {
          title: "UPDATE CA",
          authRequired: true,
          acc: 'y72410'
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "qe-photo_album",
        component: () =>
          import("@/views/qe/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
          authRequired: true,
          acc: 'y54282'
        },
      },
      //gazette
      {
        path: "gazette",
        name: "qe-gazette",
        component: () =>
          import("@/views/qe/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
          authRequired: true,
        },
      },
      //exam card
      {
        path: "exam_card",
        name: "qeStudentsExamcard",
        component: () => import("@/views/qe/examcard.vue"),
        meta: {
          title: "QE EXAM CARD",
          authRequired: true,
          acc: 'y54282'

        },
      },
      //subject Analysis
      {
        path: "subject-analysis",
        name: "qeSubjectAnalysis",
        component: () =>
          import("@/views/qe/subject-analysis.vue"),
        meta: {
          title: "SUBJECT ANALYSIS",
          acc: 'y65686',
          authRequired: true,
        },
      },

      //Attendance
      {
        path: "exam-subjects",
        name: "qeExamSubject",
        component: () => import("@/views/qe/attendance/List.vue"),
        meta: {
          title: "QE Examination Subject Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
      {
        path: "mark-exam-attendance",
        name: "qeExamAttendance",
        component: () => import("@/views/qe/attendance/index.vue"),
        meta: {
          title: "QE Examination Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
      {
        path: "exam-attendance",
        name: "qeMExamAttendance",
        component: () => import("@/views/qe/attendance/view.vue"),
        meta: {
          title: "Marked QE Examination Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
    ],
  },
];
